module.exports = __webpack_public_path__ + "static/media/emptytray.d75b456c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emptytray.svg
// module id = 1493
// module chunks = 0